export default __webpack_public_path__ + "static/media/imageThree.765b2009.png";